import {IStorage} from '../interfaces/storage.interface';

export class SqlStorage implements IStorage {
    getUid() {
        let uid = window.navigator.mimeTypes.length + '';
        uid += window.navigator.userAgent.replace(/\D+/g, '');
        uid += window.navigator.plugins.length;
        uid += window.screen.height || '';
        uid += window.screen.width || '';
        uid += window.screen.pixelDepth || '';

        // @ts-ignore
        const du = new DeviceUUID().parse();
        const dua = [
            du.language,
            du.platform,
            du.os,
            du.cpuCores,
            du.isAuthoritative,
            du.silkAccelerated,
            du.isKindleFire,
            du.isDesktop,
            du.isMobile,
            du.isTablet,
            du.isWindows,
            du.isLinux,
            du.isLinux64,
            du.isMac,
            du.isiPad,
            du.isiPhone,
            du.isiPod,
            du.isSmartTV,
            du.pixelDepth,
            du.isTouchScreen
        ];
        const uniqueUniqueid = uid + du.hashMD5(dua.join(':'));

        return uniqueUniqueid;
    }

    getItem(key: string): string {
        // console.log(this.getUid());
        // @ts-ignore
        const cookie = Cookies.get(key);

        return (!cookie ? '' : cookie);

        // return localStorage.getItem(key);
    }

    setItem(key: string, value: string): void {
        // @ts-ignore
        return Cookies.set(key, value, {expires: 120, path: '/'});

        // localStorage.setItem(key, value);
    }

    removeItem(key: string): void {
        // @ts-ignore
        Cookies.remove(key);
        // localStorage.removeItem(key);
    }
}
